import React from 'react';

const SelectionFooter = ({
  count,
  canCreateGroup,
  jobGroups,
  onCreateGroup,
  onAddToGroup,
  onClear,
  onConfirm,
}) => (
  <div className="selection-footer">
    <div className="selection-footer-actions">
      <button
        type="button"
        className="btn btn-secondary btn-touch"
        style={{ color: '#333', background: '#eee' }}
        onClick={onClear}
      >
        Clear
      </button>
      <button
        type="button"
        className="btn btn-primary btn-touch"
        onClick={onConfirm}
        disabled={count === 0}
      >
        {count > 0 ? `Select ${count}` : 'Select'}
      </button>
      {canCreateGroup && (
        <button type="button" className="btn btn-primary btn-touch" onClick={onCreateGroup}>
          Group
        </button>
      )}
    </div>
    {jobGroups.length > 0 && count > 0 && (
      <select
        className="selection-select selection-select-footer"
        defaultValue=""
        onChange={(e) => {
          if (e.target.value) onAddToGroup?.(e.target.value);
          e.target.value = '';
        }}
      >
        <option value="" disabled>Add to existing group…</option>
        {jobGroups.map((g) => (
          <option key={g.group_id} value={g.group_id}>{g.name}</option>
        ))}
      </select>
    )}
  </div>
);

export default SelectionFooter;
